import { render, staticRenderFns } from "./WrapperOrdersCards.vue?vue&type=template&id=5f64bae1&"
import script from "./WrapperOrdersCards.vue?vue&type=script&lang=ts&"
export * from "./WrapperOrdersCards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports